import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { soccerUrl } from '../utils/paths';
import './Login.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [devResetUrl, setDevResetUrl] = useState('');
  const [copied, setCopied] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');
    setDevResetUrl('');
    setCopied(false);

    try {
      const response = await api.forgotPassword({ email: email.trim().toLowerCase() });
      setMessage(response.message || 'If an account exists for that email, we sent reset instructions.');

      if (response.resetUrl) {
        setDevResetUrl(response.resetUrl);
      } else if (response.token) {
        setDevResetUrl(`${soccerUrl('/reset-password')}?token=${encodeURIComponent(response.token)}`);
      }
    } catch (err) {
      setError(err.message || 'Could not process your request. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCopyLink = async () => {
    if (!devResetUrl) return;
    try {
      await navigator.clipboard.writeText(devResetUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setError('Could not copy link. Select and copy it manually.');
    }
  };

  return (
    <div className="auth-container" style={{ pointerEvents: loading ? 'none' : 'auto' }}>
      <div className="auth-card">
        <p className="auth-eyebrow">
          <Link to="/">Daily Sports Life</Link>
        </p>
        <h2>Forgot password</h2>
        <p style={{ color: '#555', fontSize: '0.95rem', marginBottom: '1rem' }}>
          Enter your account email and we&apos;ll send reset instructions if an account exists.
        </p>

        {error && <div className="alert alert-error">{error}</div>}
        {message && <div className="alert alert-success">{message}</div>}

        {devResetUrl && (
          <div className="alert" style={{ background: '#f0f7ff', border: '1px solid #b8d4f0', marginBottom: '1rem' }}>
            <p style={{ margin: '0 0 0.5rem', fontSize: '0.9rem', color: '#333' }}>
              <strong>Dev mode:</strong> email delivery is disabled on this environment. Use this one-time reset link:
            </p>
            <code style={{ display: 'block', wordBreak: 'break-all', fontSize: '0.8rem', marginBottom: '0.75rem' }}>
              {devResetUrl}
            </code>
            <button type="button" className="btn btn-secondary" onClick={handleCopyLink}>
              {copied ? 'Copied!' : 'Copy reset link'}
            </button>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              placeholder="Enter your email"
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Sending…' : 'Send reset instructions'}
          </button>
        </form>

        <div className="auth-footer">
          <Link to="/login">Back to login</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
